import CheckOutStep2 from './CheckOutStep2';

export default CheckOutStep2;
